export default import.meta.ROLLUP_FILE_URL_J_$Mq9pTS5J3cvi72Dvpzw;